/**
 * File: PlanCard.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v2.0.0
 * Created: 2025-11-19
 * Last Updated: 2026-01-09
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import { LinkButton } from "./Buttons";
import IconCard from "./IconCard";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function PlanCard({ title, cardType, plans, features }) {
    if (cardType !== "price" && cardType !== "package") {
        cardType = "price";
    }

    return (
        <>
            <div className="plan-card">
                <h3>{title}</h3>
                <div className="plan-card__price-cards">
                    {plans.map((plan) =>
                        cardType === "price" ? (
                            <PriceCard
                                key={plan.key}
                                header={plan.header}
                                cost={plan.cost}
                                model={plan.model}
                            />
                        ) : (
                            <PackageCard
                                key={plan.key}
                                header={plan.header}
                                description={plan.description}
                                buttonText={plan.buttonText}
                                buttonLink={plan.buttonLink}
                            />
                        )
                    )}
                </div>
                <div className="plan-card__icon-cards">
                    {features.map((feature) => (
                        <IconCard
                            key={feature.key}
                            icon={feature.icon}
                            text={feature.text}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function PriceCard({ header, cost, model }) {
    return (
        <>
            <div className="price-card">
                <h4 className="price-card__header">{header}</h4>
                <div className="price-card__cost">
                    <h3>{cost}</h3>
                    <p>{model}</p>
                </div>
            </div>
        </>
    );
}

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function PackageCard({ header, description, buttonText, buttonLink }) {
    return (
        <>
            <div className="package-card">
                <h4 className="package-card__header">{header}</h4>
                <p>{description}</p>
                <LinkButton
                    text={buttonText}
                    link={buttonLink}
                    isAnchor={true}
                />
            </div>
        </>
    );
}

export default PlanCard;
